import * as React from "react";
import { useIsOverflowItemVisible, MenuItem } from "@fluentui/react-components";
import type { AppTabHeader } from "./AppTabList.types";

export type AppTabListOverflowMenuItemProps = {
  header: AppTabHeader;
  ignoreIsOverflowItemVisible?: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  id: string;
};

/**
 * A menu item for an overflow menu that only displays when the tab is not visible
 */
export const AppTabListOverflowMenuItem = (
  props: AppTabListOverflowMenuItemProps
) => {
  const { header, ignoreIsOverflowItemVisible, onClick, id } = props;
  const isVisible = useIsOverflowItemVisible(header.id);

  if (!ignoreIsOverflowItemVisible && isVisible) {
    return null;
  }

  return (
    <MenuItem id={id} key={header.id} onClick={onClick} role={"menuitemradio"}>
      <div>{header.title}</div>
    </MenuItem>
  );
};
